import React from "react";
import CustomerNavbar from "../components/user/Navbar";
import CustomerFooter from "../components/user/Footer";
import { ThemeProvider } from "styled-components";
import { customerTheme } from "../theme";

import {
  Box,
} from "@chakra-ui/react";

const UserLayout = ({ children }) => {
  return (
    <ThemeProvider theme={customerTheme}>
      <Box
        bg={customerTheme.background}  // Set background using the theme
        color={customerTheme.color}    // Set color using the theme
        minH="100vh"                   // Ensure the container takes full height
        display="flex"
        flexDirection="column"         // Stack items vertically
        px={0}                         // No horizontal padding
      >
        <CustomerNavbar />
        <Box pt="72px" pb="72px">
          {children}
        </Box>
        <CustomerFooter />
      </Box>
    </ThemeProvider>
  );
};

export default UserLayout;
